<template>
  <v-container class="bg-blue full-page text-center white--text pt-5">
    <v-img contain :src="require('../assets/logo.png')" aspect-ratio="10" class="mt-5 mb-5" />
    <span class="display-2">You are not authorized on this application.</span>
    <h3 class="page-text mt-5 mb-5">
      If you think this error should not occur, please
      <u class="cursor-pointer" v-on:click="sendEmail()">contact us.</u>
    </h3>

    <v-btn class="ma-2" color="white" elevation=0 outlined v-on:click="logout">
      Logout
    </v-btn>
  </v-container>
</template>

<script>


export default {
  name: 'JailPage',
  methods: {
    sendEmail() {
      window.open('mailto:support.spacestudio@exotrail.com')
    },
    async logout() {
      delete localStorage.token
      delete localStorage.currentMissionId
      await this.$store.dispatch('logout')
      const referUrl = encodeURI(window.location.origin + window.location.pathname)
      const guardianUrl = process.env.GUARDIAN_URL
      const appName = process.env.APP_NAME
      window.location.href = `${guardianUrl}/#/?refer=${referUrl}&from=${appName}&goto=logout`
    }
  }
}
</script>

<style scoped>
.bg-blue {
  background-color: #1a64c6;
}

.full-page {
  max-width: 100% !important;
  width: 100% !important;
}

.page-text {
  font-weight: inherit;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
